import React from 'react';
import { Section, SectionHeader } from './ui/Section';
import { Reveal } from './ui/Reveal';
import { Card } from './ui/Card';
import { DollarSign, Users, Activity, Globe, Shield } from 'lucide-react';
export function MissionSection() {
  return <Section id="summary" variant="charcoal" data-id="element-261">
      <SectionHeader title="Executive Summary" subtitle="Strategic Profile" data-id="element-262" />

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12" data-id="element-263">
        <div className="lg:col-span-7" data-id="element-264">
          <Reveal data-id="element-265">
            <p className="text-xl text-slate-300 leading-relaxed mb-8 font-light border-l-4 border-gold-500 pl-6" data-id="element-266">
              A retired Senior Executive Service (SES) Tier I & II leader with
              over four decades of high-stakes logistics, acquisition, and
              operational experience across the Department of Defense, Joint
              Staff, and Combatant Commands.
            </p>
            <p className="text-slate-400 leading-relaxed mb-6" data-id="element-267">
              Proven authority in enterprise modernization, governance, and
              crisis response, having directed multi-billion dollar portfolios
              and led global supply chain operations during some of the most
              critical challenges of the 21st century. Currently leveraging this
              deep expertise to drive strategic growth and sustainment solutions
              for defense industry partners.
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-5 space-y-4" data-id="element-268">
          <Reveal delay={200} data-id="element-269">
            <div className="flex items-center gap-4 p-4 bg-navy-900 border border-white/5 rounded-sm" data-id="element-270">
              <DollarSign className="text-gold-500 w-6 h-6 flex-shrink-0" data-id="element-271" />
              <div data-id="element-272">
                <span className="block text-white font-bold text-lg" data-id="element-273">
                  $42B+
                </span>
                <span className="text-slate-400 text-sm" data-id="element-274">
                  Annual Operations Leadership
                </span>
              </div>
            </div>
          </Reveal>

          <Reveal delay={300} data-id="element-275">
            <div className="flex items-center gap-4 p-4 bg-navy-900 border border-white/5 rounded-sm" data-id="element-276">
              <Shield className="text-gold-500 w-6 h-6 flex-shrink-0" data-id="element-277" />
              <div data-id="element-278">
                <span className="block text-white font-bold text-lg" data-id="element-279">
                  $18B+
                </span>
                <span className="text-slate-400 text-sm" data-id="element-280">
                  Acquisition Portfolio Oversight
                </span>
              </div>
            </div>
          </Reveal>

          <Reveal delay={400} data-id="element-281">
            <div className="flex items-center gap-4 p-4 bg-navy-900 border border-white/5 rounded-sm" data-id="element-282">
              <Users className="text-gold-500 w-6 h-6 flex-shrink-0" data-id="element-283" />
              <div data-id="element-284">
                <span className="block text-white font-bold text-lg" data-id="element-285">
                  27,000+
                </span>
                <span className="text-slate-400 text-sm" data-id="element-286">
                  Personnel Enterprise Leadership
                </span>
              </div>
            </div>
          </Reveal>

          <Reveal delay={500} data-id="element-287">
            <div className="flex items-center gap-4 p-4 bg-navy-900 border border-white/5 rounded-sm" data-id="element-288">
              <Activity className="text-gold-500 w-6 h-6 flex-shrink-0" data-id="element-289" />
              <div data-id="element-290">
                <span className="block text-white font-bold text-lg" data-id="element-291">
                  Crisis Response
                </span>
                <span className="text-slate-400 text-sm" data-id="element-292">
                  COVID-19, Ebola, Hurricanes
                </span>
              </div>
            </div>
          </Reveal>

          <Reveal delay={600} data-id="element-293">
            <div className="flex items-center gap-4 p-4 bg-navy-900 border border-white/5 rounded-sm" data-id="element-294">
              <Globe className="text-gold-500 w-6 h-6 flex-shrink-0" data-id="element-295" />
              <div data-id="element-296">
                <span className="block text-white font-bold text-lg" data-id="element-297">
                  Modernization
                </span>
                <span className="text-slate-400 text-sm" data-id="element-298">
                  Enterprise Governance Expertise
                </span>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </Section>;
}